import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { getCruiseVendorBookingTimer } from 'lib/cruises/cruiseUtils'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { getRemainingCruiseSessionTime } from './utils'

function CruiseSessionCountdownMessage() {
  const [timeRemaining, setTimeRemaining] = useState(getRemainingCruiseSessionTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(getRemainingCruiseSessionTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const showModal = useContext(ModalContext)

  const openInfoModal = useCallback(() => {
    showModal(<Modal title="Cruise prices">
      <BodyText variant="large">
        Due to demand and availability, cruise prices can fluctuate quickly.{' '}
        We can hold your cruises for a {getCruiseVendorBookingTimer()} minute period before your session expires.{' '}
        Hurry and book now before prices increase!
      </BodyText>
    </Modal>)
  }, [showModal])

  return <Group direction="horizontal" verticalAlign="center" horizontalAlign="center" gap={8} wrap="wrap">
    <BodyTextBlock variant="medium" endIcon={<Clickable onClick={openInfoModal}><LineInfoCircleIcon /></Clickable>}>
      Cruise prices held for {getCruiseVendorBookingTimer()} minutes
    </BodyTextBlock>
    <StatusLabel variant="cancelled">{timeRemaining.minutes} : {timeRemaining.seconds} remaining</StatusLabel>
  </Group>
}

export default CruiseSessionCountdownMessage
